import { Button, Tooltip, TooltipBody, TooltipFooter, TooltipHeader, Typography } from '@pw-tech/omni-ui';
import React, { useState } from 'react';
const TooltipComponent = ({
  position,
  origin = 'center',
  variant = 'dark',
  showCloseIcon = true,
  className = '',
  labelChildren,
  bodyChildren,
  footerChildren,
  showHeader = true,
  showFooter = true,
  headerTitle = '',
  isOpen,
  onClose
}: {
  position: 'top' | 'bottom' | 'left' | 'right';
  origin: 'center' | 'end' | 'start';
  variant?: 'dark' | 'light';
  showCloseIcon?: boolean;
  className?: string;
  labelChildren?: React.ReactNode;
  bodyChildren?: React.ReactNode;
  footerChildren?: React.ReactNode;
  showHeader?: boolean;
  showFooter?: boolean;
  headerTitle?: string;
  isOpen?: boolean;
  onClose?: () => void;
}) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const tooltipOpen = isOpen !== undefined ? isOpen : internalOpen;
  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      setInternalOpen(false);
    }
  };
  return <Tooltip label={labelChildren} origin={origin} position={position} showCloseIcon={showCloseIcon} variant={variant} open={tooltipOpen} onClose={handleClose} data-sentry-element="Tooltip" data-sentry-component="TooltipComponent" data-sentry-source-file="TooltipComponent.tsx">
      <div className="p-4">
        {showHeader ? <TooltipHeader>
            <Typography className="text-14 md:text-16 lg:text-18" color="static-white" variant="subHeading" weight="bold">
              {headerTitle}
            </Typography>
          </TooltipHeader> : <></>}
        <TooltipBody data-sentry-element="TooltipBody" data-sentry-source-file="TooltipComponent.tsx">{bodyChildren}</TooltipBody>
        {showFooter && <TooltipFooter>{footerChildren}</TooltipFooter>}
      </div>
    </Tooltip>;
};
export default TooltipComponent;